import React, { lazy, Suspense } from "react";
import dynamicIconImports from "lucide-react/dynamicIconImports";

const LucideIconDynamic = (props: {
    name: string;
    color?: string;
    height?: number;
    width?: number;
    strokeWidth?: number;
}) => {
    // @ts-ignore
    const LucideIcon = lazy(dynamicIconImports[props.name]);
    return (
        <Suspense fallback={<div></div>}>
            <LucideIcon {...props} />
        </Suspense>
    );
};
export default LucideIconDynamic;